import styled, { keyframes } from "styled-components";

interface BubbleProps {
  className?: string;
}

const bubble = keyframes`
  0% {
    transform: translateY(0%);
    opacity: 0.06;
  }
  100% {
    transform: translateY(-120vh);
  }
`;

const BubbleContainer = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 100%;
  position: absolute;
  background-color: white;
  opacity: 0.2;
  z-index: 1;
  animation: ${bubble} 15s ease-in-out infinite;
`;

export const Bubble = ({ className }: BubbleProps) => {
  return <BubbleContainer className={className}></BubbleContainer>;
};
